import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/AppShell";
import AuthPage from "@/pages/AuthPage";
import Onboarding from "@/pages/Onboarding";
import LogPage from "@/pages/LogPage";
import Journal from "@/pages/Journal";
import SessionPage from "@/pages/SessionPage";
import TagPage from "@/pages/TagPage";
import Quizzes from "@/pages/Quizzes";
import QuizPlay from "@/pages/QuizPlay";
import Leaderboard from "@/pages/Leaderboard";
import Profile from "@/pages/Profile";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Admin from "@/pages/Admin";
import OfflinePractice from "@/pages/OfflinePractice";
import Landing from "@/pages/Landing";
import Analytics from "@/pages/Analytics";
import VerifyEmail from "@/pages/VerifyEmail";
import Upgrade from "@/pages/Upgrade";
import { PaymentCancel, PaymentSuccess } from "@/pages/Payment";

function Splash() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]" data-testid="app-loading">
      <div className="font-display text-2xl font-bold tracking-tight">
        ROLL <span className="text-[#E50914]">SMARTR</span>
      </div>
    </div>
  );
}

function AppRoutes() {
  const { user } = useAuth();
  if (user === null) return <Splash />;
  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<AuthPage mode="login" />} />
        <Route path="/register" element={<AuthPage mode="register" />} />
        <Route path="/" element={<Landing />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }
  if (user.email_verified === false) {
    return (
      <Routes>
        <Route path="*" element={<VerifyEmail />} />
      </Routes>
    );
  }
  if (!user.onboarded) {
    return (
      <Routes>
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="*" element={<Navigate to="/onboarding" replace />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={<LogPage />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/session/:id" element={<SessionPage />} />
        <Route path="/tag/:name" element={<TagPage />} />
        <Route path="/quizzes" element={<Quizzes />} />
        <Route path="/plan" element={<Navigate to="/quizzes" replace />} />
        <Route path="/ranks" element={<Leaderboard />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/pro" element={<Upgrade />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
      </Route>
      <Route path="/quiz/:id" element={<QuizPlay />} />
      <Route path="/practice/:topic" element={<OfflinePractice />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<AppRoutes />} />
        </Routes>
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{ style: { background: "#161618", border: "1px solid #27272A", color: "#fff" } }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}
